
import { Toolbar, ToolbarProps } from '@mui/material'
import React from 'react'

export type WcToolbarProps =  ToolbarProps

export const WcToolbar = ({children,...props}: WcToolbarProps) => (
    <Toolbar {...props}>{children}</Toolbar>
  )